<template>
<body class="mob-overflow">
  <div class="mainview_style">
    <header class="mob-display common--header">
      <b-row class="marginTopAlignment">
        <b-col cols="2" v-on:click="backAction()"><img src="images/Back_white.svg" alt=""/></b-col>
        <b-col cols="8" class="header-title text-center">TEST RESULT</b-col>
      </b-row>
    </header>
    <header class="desk_display">
      <div id="header_content" class="common--header">
        <p class="alignleft"></p>
        <p class="aligncenter header-title">TEST RESULT</p>
        <p class="alignright" v-on:click="gomenu()">
           <img src="images/Home@2x.png" alt/>          
        </p>
      </div>
      <div style="clearaligncenter: both;"></div>
    </header>
    <b-container class="bv-example-row testRes_height mob_col_padding footer_bottom">
      <b-row align-h="center" class="dev_lr_margin row_height">
        <b-col class="col-sm-12 col-md-5 mob_col_padding dev_position">
    <b-container v-if="showTestResult">
      <div class="testResultContentDiv">
        <div class="testResultDivStyle">
          <label class="staticLabelStyle">{{ this.testDate }}</label>
          <label class="testResultInputstyle">{{ testResult.tstdon }}</label>
        </div>
        <div class="testResultDivStyle">
          <table class="testTableStyle">
            <tr>
              <th class="staticLabelStyle">{{ this.testName }}</th>
              <th class="staticLabelStyle">{{ this.testResultTitle }}</th>
            </tr>

            <tr v-for="results in testResult.res" v-bind:key="results.tstnm">
              <td class="testTableContentStyle">{{ results.tstnm }}</td>
              <td class="testTableContentStyle" :class="results.flag">{{ results.flg }}</td>
            </tr>
          </table>
        </div>
        <div>
          <img class="testImage" src="images/compliance_green.png" />
          <a href="javascript:void(0);" @click="goResource" class="testHyperLink"> {{ this.howToReadResult }}</a>
        </div>
      </div>
    </b-container>
    <b-container class="containerstyle">
      <div v-if="showNoResults" class="successMsgdiv">
        <label class="thankyouText">{{ errorMessage }}</label>
      </div>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </div>
  <Footer></Footer>
</body>
</template>

<script>
import apiCall from "@/services/api/apicall";
import { store } from "@/store.js";
import moment from "moment";
import Footer from "@/components/footer";

export default {
  name: "",
  components: {
    Footer,
  },
  data() {
    return {
      store: store,
      testResult: [],
      showTestResult: false,
      showNoResults: false,
      errorMessage: this.noTestResults,
    };
  },
  methods: {
    backAction() {
      this.$router.push({ path: "/app-home" });
    },
    gomenu() {
      this.$router.push({ path: "/app-home" });
    },
    goResource() {
      this.$router.push({ path: "/resources" });
    },
  },
  mounted() {
    if (navigator.onLine) {
    var urlString = "/result";

    apiCall
      .apiServiceCall("GetOne", "", urlString, "", "")
      .then(response => {
          if (response.data.status == 1) {
            if (Object.keys(response.data.data).length === 0) {
              this.showTestResult = false;
              this.showNoResults = true;
              this.errorMessage = this.noTestResults;
            } else {
              this.testResult = response.data.data;
              var date = moment(String(this.testResult.tstdon.split("T")[0])).format("M/D/YYYY");
              this.testResult.tstdon = date;
              this.showTestResult = true;
              this.showNoResults = false;
            }
          } else {
            this.showTestResult = false;
            this.showNoResults = true;
            this.errorMessage = response.data.message;
          }
      })
      .catch(error => {
        if (error.response.status == 500) {
          this.showTestResult = false;
          this.showNoResults = true;
          this.errorMessage = this.serverProblem;
        } else if (error.response.status == 401) {
          setTimeout(() => this.$router.push({ path: "/home" }), 2000);
        } else if (error.response.status == 504) {
          this.signout();
        }  else {
          this.showTestResult = false;
          this.showNoResults = true;
          this.errorMessage = error.response.data.message;
        }
      });

    } else {
      this.showTestResult = false;
      this.showNoResults = true;
      this.errorMessage = this.checkInternetConnection;
    }
  },
};
</script>
